import {MissionType} from "./mission";

export enum PossibleValuesManagement {
  MENU="menu",
  AUTOCOMPLETE="autocomplete",
  RANGE="range",
}

export interface DependenceType {
  scope: string,
  values: {
    possibleValues?: string[],
    minValue?: number,
    maxValue?: number,
  },
  constrains: {
    name: string,
    possibleValues?: string[],
    minValue?: number,
    maxValue?: number,
    isApplicable: boolean,
    isMandatory: boolean
  }
}

export interface DependenciesType {
  All?: DependenceType[],
  Ondemand?: DependenceType[],
  Routine?: DependenceType[],
}

export interface FieldType {
  description: string,
  type: string,
  name: string,
  sequence: number,
  possibleValues ?: string[]
}

export interface DefaultSearchFieldType extends FieldType {
  isApplicable?: boolean,
  isMandatory: boolean,
  prodParam?: boolean,
  search: boolean,
  operator: string,
  dependences?: DependenciesType,
  tooltip?: string,
  placeholder?: string,
  isMultiSelection?: boolean,
}

export interface MenuSearchFieldType extends DefaultSearchFieldType {
  possibleValuesManagement: PossibleValuesManagement.MENU,
  possibleValues: string[],
}

export interface AutocompleteSearchFieldType extends DefaultSearchFieldType {
  possibleValuesManagement: PossibleValuesManagement.AUTOCOMPLETE,
}

export interface RangeSearchFieldType extends DefaultSearchFieldType {
  possibleValuesManagement: PossibleValuesManagement.RANGE,
  minValue: number,
  maxValue: number,
  step: number,
}

export interface NumberSearchFieldType extends DefaultSearchFieldType {
  minValue: number,
  maxValue: number,
  step: number,
}

export interface TextSearchFieldType extends DefaultSearchFieldType {
}

export type SearchFieldType = MenuSearchFieldType | AutocompleteSearchFieldType | NumberSearchFieldType | TextSearchFieldType | RangeSearchFieldType;

export interface MissionConfigurationsType extends MissionType {
  isApplicable: boolean,
  fields: {
    "advanced-search": SearchFieldType[],
    "processing-parameters"?: SearchFieldType[],
  },
  index?: string
}

export interface AdvancedSearchConfigurationsType {
  description?: string,
  productCategory: string,
  productName: string,
  missions: MissionConfigurationsType[],
  fields: {
    sort: FieldType[],
  }
}

export interface SearchConfigurationsType {
  description?: string,
  productCategory: string,
  productName: string,
  fields: {
    sort: FieldType[],
    search: SearchFieldType[],
  }
}

export type ConfigurationsType = AdvancedSearchConfigurationsType | SearchConfigurationsType;
